import React from 'react';
import Icon from 'components/mweb/Icon/Icon';
import { Link } from 'react-router-dom';
import {
  DEFAULT_COORDS,
  getAddressFields,
  initializeMap,
  initializeMapNode,
  setGeoLocationPosition,
} from 'hb-redux-store/util/locationService';
import { showCart } from 'hb-redux-store/feature/cart/cart.action';
import history from 'hb-redux-store/history';
import { checkoutPrefix, getCheckoutRoute } from './checkout.routes';
import {
  postDeliveryAddress,
  addNewDeliveryAddress,
  updateDeliveryAddress,
  validateSelectedLocationForNudge,
  removeShoppingCart,
} from 'hb-redux-store/feature/checkout/checkout.action';
import { connect } from 'react-redux';
import Input from 'components/mweb/Input/Input';
import Button from 'components/common/Button/Button';
import ResetCartOnAdcChangeModal from 'components/mweb/Modal/ResetCartOnAdcChangeModal';
import { CUSTOMER_TYPE } from 'hb-redux-store/util/constantServices';
import { ACCOUNTS_PREFIX } from '../account/accounts.routes';
import Drawer from 'components/common/Drawer';
import {
  showLocationSearchModal,
  showAddressListModal,
} from 'hb-redux-store/feature/modal/modal.action';
import MarkerRadar from '../../common/MarkerRadar/MarkerRadar';
import {
  getSubscriptionRoute,
  subscriptionPrefix,
} from '../Subscription/subscription.routes';

const { geolocation = {} } = window?.navigator;

class AddAddress extends React.Component {
  constructor(props) {
    super(props);
    // this.isAccounts = props.location.pathname.indexOf('/my/new-address') > -1;
    // this.isCheckout = !this.isAccounts;
    // const prefix = this.isAccounts ? ACCOUNTS_PREFIX : checkoutPrefix;
    this.isCheckout = props.prefix === checkoutPrefix;
    this.isAccounts = props.prefix === ACCOUNTS_PREFIX;
    this.isSubscription = props.prefix === subscriptionPrefix;
    this.mapLink = `/${props.prefix}/location`;
    this.addressCta = this.isAccounts
      ? 'Save Address'
      : 'Save and deliver to this address';
    this.state = {
      locationDetails: null,
      primaryText: null,
      secondaryText: null,
      addressId: '',
      fullName: props.launchInfo?.customerFullName || '',
      nameError: false,
      mobile: props.launchInfo?.mobile,
      addressLine1: '',
      landmark: '',
      area: '',
      mapLocation: '',
      city: '',
      state: '',
      pinCode: '',
      addressType: '',
      latitude: '',
      longitude: '',
      isDefaultAddress:
        props.launchInfo?.customerType === CUSTOMER_TYPE.NEW_USER,
      addressLine1Error: false,
      mapDragged: false,
      showNudge: false,
      showAddress: true,
      nudgeObject: {},
      accounts: !!this.isAccounts,
      onMarkerChanged: 0,
      showMapTooltip: true,
      showAddressForm: false,
      serviceableArea: false,
      subscriptionAddress: this.isSubscription,
    };
  }

  ADDRESS_TYPES = [
    { key: 'Home', name: 'Home' },
    { key: 'Office', name: 'Office' },
    { key: null, name: 'Other' },
  ];
  onDragStart = () =>
    this.setState({ showMapTooltip: false, serviceableArea: false });
  onMarkerChange = locationDetails => {
    const state = {
      locationDetails,
      ...getAddressFields(locationDetails),
      onMarkerChanged: this.state.onMarkerChanged + 1,
      mapDragged: this.state.onMarkerChanged > 0,
      showMapTooltip: true,
      subscriptionAddress: this.isSubscription,
    };
    this.props.validateSelectedLocationForNudge(state, resp => {
      this.setState({
        ...state,
        showNudge: resp?.resetCart,
        nudgeObject: resp,
        serviceableArea: !resp.error && resp?.action !== 'failure',
      });
    });
  };
  setModal = (showModal, nudgeObject) => {
    const state = { showModal };
    if (nudgeObject) state.nudgeObject = nudgeObject;
    this.setState(state);
  };
  setLocationState = locationDetails => {
    this.setState({
      locationDetails,
      ...getAddressFields(locationDetails),
    });
  };

  componentDidMount() {
    this.reloadMap();
  }

  reloadMap = () => {
    const addressId = this.props.addressId;
    // const { addressId } = this.props.match.params;
    const { completeAddressesList, showCart } = this.props;
    if (completeAddressesList?.length === 0) {
      showCart();
    }
    if (addressId && completeAddressesList) {
      const address = completeAddressesList.find(x => x.addressId == addressId);
      if (address) {
        this.setState(
          {
            fullName: address.fullName,
            mobile: address.mobile,
            addressLine1: address.addressLine1,
            landmark: address.landmark,
            isDefaultAddress: address.default,
            addressType: address.addressType || null,
          },
          () => {
            initializeMap({
              coords: {
                latitude: address?.latitude,
                longitude: address?.longitude,
              },
            });
            initializeMapNode(
              '.add-new-address--map#new-address-map',
              this.onMarkerChange,
              this.onDragStart
            )
              .then(locationDetails => {
                console.log('locationDetails: ', locationDetails);
                this.setLocationState(locationDetails);
              })
              .catch(e => {
                console.log('error: ', e);
                if (e === 'placeId not found') {
                  const defaultGeoLocation = { coords: DEFAULT_COORDS };
                  setGeoLocationPosition(defaultGeoLocation);
                  // history.goBack();
                }
              });
            this.props.validateSelectedLocationForNudge(
              { ...address, subscriptionAddress: this.isSubscription },
              resp => {
                this.setState({
                  nudgeObject: resp,
                  showNudge: resp?.resetCart,
                });
              }
            );
          }
        );
      }
    } else if (!addressId) {
      initializeMapNode(
        '.add-new-address--map#new-address-map',
        this.onMarkerChange,
        this.onDragStart
      )
        .then(locationDetails => {
          console.log('locationDetails: ', locationDetails);
          this.setLocationState(locationDetails);
        })
        .catch(e => {
          console.log('error: ', e);
          if (e === 'placeId not found') {
            const defaultGeoLocation = { coords: DEFAULT_COORDS };
            setGeoLocationPosition(defaultGeoLocation);
            // history.goBack();
          }
        });
    }
  };
  UNSAFE_componentWillReceiveProps(nextProps) {
    const addressId = this.props.addressId;
    if (
      this.props.completeAddressesList?.length !==
      nextProps?.completeAddressesList?.length
    ) {
      const address =
        nextProps.completeAddressesList?.find(x => x.addressId == addressId) ||
        {};
      const state = {
        fullName: address.fullName,
        mobile: address.mobile,
        addressLine1: address.addressLine1,
        landmark: address.landmark,
        isDefaultAddress: address.default,
        addressType: address.addressType || null,
      };
      if (this.props.actionType === 'edit') {
        state.addressId = addressId;
      }
      this.setState(state, () => {
        initializeMap({
          coords: {
            latitude: address.latitude,
            longitude: address.longitude,
          },
        });
        initializeMapNode(
          '.add-new-address--map#new-address-map',
          this.onMarkerChange,
          this.onDragStart
        )
          .then(locationDetails => {
            console.log('locationDetails: ', locationDetails);
            this.setLocationState(locationDetails);
          })
          .catch(e => {
            console.log('error: ', e);
            if (e === 'placeId not found') {
              const defaultGeoLocation = { coords: DEFAULT_COORDS };
              setGeoLocationPosition(defaultGeoLocation);
              // history.goBack();
            }
          });
      });
    }
  }
  confirmAndShowAddressForm = () =>
    this.setState({ showAddressForm: true, showMapTooltip: false });
  saveAndDeliver = () => {
    const { fullName, addressLine1, addressId } = this.state;
    const state = { nameError: false, addressLine1Error: false };
    if (!fullName) state.nameError = true;
    if (!addressLine1) state.addressLine1Error = true;
    // if (addressId || this.props.selectedAddress.addressId) {
    //   state.addressId = addressId || this.props.selectedAddress.addressId;
    // }
    if (addressId) {
      state.addressId = addressId;
    }
    state.default = this.state.isDefaultAddress;
    this.setState(state, () => {
      let nextRoute = '/my/addresses';
      if (this.isCheckout) nextRoute = getCheckoutRoute('shipment');
      if (this.isSubscription) nextRoute = getSubscriptionRoute('payment');
      if (this.state.showNudge && (this.isCheckout || this.isSubscription)) {
        this.setModal(true);
      } else if (fullName && addressLine1) {
        if (
          this.props.actionType === 'new' ||
          history.location.pathname.includes('new')
        ) {
          const addressDetails = { ...this.state };
          delete addressDetails.addressId;
          this.props.validateSelectedLocationForNudge(addressDetails, resp => {
            if (!resp?.resetCart) {
              this.props.addNewDeliveryAddress(this.state, nextRoute);
              this.closeAddressModal();
              this.props.showLocationSearchModal({
                locationSearchModal: false,
                typeOfCTA: 'changeAddress',
              });
              this.props.showAddressListModal(false);
            } else {
              this.closeAddressModal();
              this.setModal(true, resp);
            }
          });
        } else if (
          this.props.actionType === 'edit' ||
          history.location.search.includes('edit')
        ) {
          const address = { ...this.state };
          let addressApi = this.props.updateDeliveryAddress;
          if (address.mapDragged) {
            delete address.addressId;
            addressApi = this.props.addNewDeliveryAddress;
          }
          // this.props.setAppNotification('Calling updateDeliveryAddress: MapDragged? ' + address.mapDragged);
          addressApi(this.state, () => {
            history.replace(nextRoute);
          });
          this.closeAddressModal();
          this.props.showLocationSearchModal({
            locationSearchModal: false,
            typeOfCTA: 'changeAddress',
          });
          this.props.showAddressListModal(false);
        } else {
          // this.props.setAppNotification('Calling postDeliveryAddress: ');
          const address = { ...this.state };
          let addressApi = this.props.addNewDeliveryAddress;
          if (!this.state.mapDragged) {
            address.addressId = this.props.selectedAddress.addressId;
            addressApi = this.props.postDeliveryAddress;
          }
          addressApi(address, nextRoute);
          this.closeAddressModal();
          this.props.showLocationSearchModal({
            locationSearchModal: false,
            typeOfCTA: 'changeAddress',
          });
          this.props.showAddressListModal(false);
        }
      }
    });
  };

  setAddressType = add => {
    this.setState({ addressType: add.key });
  };

  closeAddressModal = () => {
    const { showModal } = this.props;
    showModal && showModal(false);
    this.setState({ showAddress: false });
  };

  render() {
    const {
      fullName,
      nameError,
      mobile,
      addressLine1,
      landmark,
      area,
      mapLocation,
      addressType,
      isDefaultAddress,
      addressLine1Error,
      showMapTooltip,
      showAddressForm,
    } = this.state;
    return (
      <div className="add-new-address">
        {/* {!mapLocation && <Loader />} */}
        <React.Fragment>
          <Drawer
            title="ENTER ADDRESS"
            placement="right"
            closable={true}
            onClose={this.closeAddressModal}
            visible={this.state.showAddress}
            destroyOnClose={true}
            maskClosable={false}
            width={500}
            afterVisibleChange={this.reloadMap}
            footer={
              showAddressForm ? (
                <div>
                  <Button
                    className="button button-primary full-width large"
                    onClick={this.saveAndDeliver}
                  >
                    {this.addressCta}
                  </Button>
                </div>
              ) : (
                false
              )
            }
          >
            <div
              className="location-map--map-container"
              style={{ height: '50vh' }}
            >
              <div
                id="new-address-map"
                className="add-new-address--map"
                style={{ height: '50vh' }}
              ></div>
              <MarkerRadar tooltipVisible={showMapTooltip} desktop />
              {geolocation && (
                <div
                  className="location-map--map-container--crosshair"
                  onClick={this.getCurrentLocation}
                >
                  <Icon class="icon-location-crosshair" size={30} />
                </div>
              )}
            </div>
            <div className="add-new-address-desktop-address-detail">
              <div className="add-new-address-desktop-address-detail--address">
                <Icon
                  size={30}
                  class="icon-location-bar-location-marker flex-shrink-0"
                />
                <div className="add-new-address-desktop-address-detail--primary-text ellipsis">
                  {area}
                </div>
                {this.props.actionType === 'new' && (
                  <Link
                    onClick={() => {
                      this.props.showLocationSearchModal({
                        locationSearchModal: true,
                        typeOfCTA: 'changeAddress',
                      });
                      this.props.showAddressListModal(false);
                      this.closeAddressModal();
                    }}
                    className="desktop-order-details--highlights--invoice  desktop-cart--address-detail--change-link button action-link more flex-shrink-0"
                  >
                    Change
                  </Link>
                )}
              </div>
              <div className="add-new-address-desktop-address-detail--secondary-text">
                {mapLocation}
              </div>
            </div>
            {!showAddressForm && (
              <Button
                className="button button-primary full-width large"
                onClick={() => {
                  this.setState({ showAddressForm: true }, () => {
                    setTimeout(() => {
                      const selector = '#address-form';
                      document.querySelector(selector).scrollIntoView({
                        behavior: 'smooth',
                      });
                    }, 200);
                  });
                }}
                disabled={!this.state.serviceableArea}
              >
                Confirm Location
              </Button>
            )}
            {showAddressForm && (
              <div className="add-new-address-desktop-form" id="address-form">
                <Input
                  type="text"
                  name="fullName"
                  value={fullName}
                  onChange={({ fullName }) => this.setState({ fullName })}
                  maxLength="50"
                  placeholder="Name"
                  required={true}
                  hasError={nameError}
                  errorMsg="Please add name"
                  onBlur={({ fullName }) =>
                    fullName?.length && this.setState({ nameError: false })
                  }
                />
                <Input
                  type="mobile"
                  name="mobile"
                  value={mobile}
                  onChange={({ mobile }) => this.setState({ mobile })}
                  placeholder="Mobile No"
                  maxLength="14"
                />
                <Input
                  type="text"
                  name="addressLine1"
                  value={addressLine1}
                  onChange={({ addressLine1 }) =>
                    this.setState({ addressLine1 })
                  }
                  placeholder="Flat, House no., Building, Company, Apartment"
                  required={true}
                  hasError={addressLine1Error}
                  errorMsg="Please add address details"
                  onBlur={({ addressLine1 }) =>
                    addressLine1?.length &&
                    this.setState({ addressLine1Error: false })
                  }
                />
                <Input
                  type="text"
                  name="landmark"
                  value={landmark}
                  onChange={({ landmark }) => this.setState({ landmark })}
                  placeholder="Landmark e.g. near apollo hospital"
                />
                <div className="add-new-address-desktop-form--address-type">
                  <div>Address Type</div>
                  <div className="add-new-address-desktop-form--address-type--types">
                    {this.ADDRESS_TYPES.map(add => {
                      return (
                        <div
                          key={add.key}
                          className={`add-new-address-desktop-form--address-type--address ${
                            addressType === add.key ? 'active' : ''
                          } `}
                          onClick={() => this.setAddressType(add)}
                        >
                          {add.name}
                        </div>
                      );
                    })}
                  </div>
                </div>
                <div
                  className="add-new-address-desktop-form--default-address justify-content--space-between"
                  onClick={() =>
                    this.setState({ isDefaultAddress: !isDefaultAddress })
                  }
                >
                  <div>Make this address default</div>
                  <Icon
                    class={
                      isDefaultAddress
                        ? 'icon-common-checkbox-selected'
                        : 'icon-common-checkbox-unselected'
                    }
                    size={20}
                  />
                </div>
              </div>
            )}
            <ResetCartOnAdcChangeModal
              visible={this.state.showModal}
              onCancel={() => this.setModal(false)}
              onOk={() => {
                const {
                  adcCode,
                  cityId,
                  newAddress,
                  resetCart,
                } = this.state.nudgeObject;
                const address = {
                  ...this.state,
                  adcCode,
                  cityId,
                  newAddress,
                  resetCart,
                };
                delete address.nudgeObject;
                this.props.removeShoppingCart(address, () => {
                  this.closeAddressModal();
                  showCart();
                });
              }}
            />
          </Drawer>
        </React.Fragment>
      </div>
    );
  }
}

const mapStateToProps = ({ cartReducer, initialReducer }) => ({
  selectedAddress: cartReducer.selectedAddress,
  isLoggedIn: initialReducer.isLoggedIn,
  completeAddressesList: cartReducer.completeAddressesList,
  launchInfo: initialReducer.launchInfo,
});
const mapDispatchToProps = {
  postDeliveryAddress,
  addNewDeliveryAddress,
  updateDeliveryAddress,
  showCart,
  validateSelectedLocationForNudge,
  removeShoppingCart,
  showLocationSearchModal,
  showAddressListModal,
  // setAppNotification,
};

export default connect(mapStateToProps, mapDispatchToProps)(AddAddress);
